import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from 'constants/common';
import { AppointmentService } from 'services/appointments';
import { PatientService } from 'services/patients';
import { type Appointment } from 'types/appointments';
import { separateAppointmentsByDate } from 'utils/appointments';
import { getUserId } from 'utils/storage';

export interface PatientAppointments {
  past: Appointment[];
  future: Appointment[];
}

export const useFetchPatientAppointments = (
  patientId: string
): UseQueryResult<PatientAppointments> =>
  useQuery({
    queryKey: [QUERY_KEYS.FETCH_PATIENT_APPOINTMENTS, patientId],
    queryFn: async () => {
      const psychologistId = getUserId();
      const { data: appointments } = await AppointmentService.getAppointments(
        patientId,
        psychologistId
      );
      const appointmentsWithCenter = await Promise.all(
        appointments.map(async appointment => {
          const center = await AppointmentService.getCenterDetails(appointment.backofficeCenterId);
          return {
            ...appointment,
            center: center.data,
            patient: (await PatientService.getPatient(patientId)).data,
          } as Appointment;
        })
      );
      return separateAppointmentsByDate(appointmentsWithCenter);
    },
    enabled: !!patientId,
  });
